export enum STUDENT_FILTER_FORM_CONTROL {
    SEARCH_KEY = 'SEARCH_KEY',
    COLLEGE = 'COLLEGE',
    COURCE = 'COURCE',
    SKILL = 'SKILL',
    BATCH = 'BATCH'
}
